module.exports = __webpack_public_path__ + "img/image3.8a7d6560.png";